<div *ngIf="employeeInfoReport">
    <div class="appraisee-info-module">
        <div *ngIf="!isIndividualBriefReport" class="caption">
            {{ 'lang.user.appraisee' | translate }}
        </div>
        <div *ngIf="isIndividualBriefReport">{{ endDate | date:'dd.MM.yyyy' }}</div>
        <div class="appraisee-name">{{ employeeInfoReport.displayName }}</div>
        <div>{{ employeeInfoReport.positionName }}</div>
        <div class="appraisee-department">{{ employeeInfoReport.businessUnitName }}</div>
    </div>
</div>
